export default __webpack_public_path__ + "static/media/dog-thanks-you.6b1db9a5.gif";